<template>
  <div>
       <b-modal v-model="modalShow">
           <b-container>
               <b-row>

               </b-row>
           </b-container>
       </b-modal>
  </div>
</template>

<script>
export default {
    data(){
        return {
            modalShow:false
        }
    }
}
</script>

<style>

</style>